import type { TsCodeType } from '../../types.js'
import { assignCommonProperties } from '../../util/data/assign-common-properties.js'

import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('FormValidationRule')
export class FormValidationRule {
	@jsonProperty(String)
	validationType!: string
	@jsonProperty(String)
	description?: string
	@jsonProperty(Boolean)
	isAsync: boolean = false
	/**
	 * config can be e.g. the validator code (string), maxLen (number), etc.
	 */
	@jsonProperty(String, {
		serializer(value) {
			return value != undefined ? JSON.stringify(value) : undefined
		},
		deserializer(json) {
			return json ? JSON.parse(json) : undefined
		},
	})
	configCode: string = ''

	@jsonProperty(String)
	messageCode: TsCodeType = ''

	constructor(init?: Partial<FormValidationRule>) {
		assignCommonProperties(this, init)
	}
}
